<template>
  <div v-if="rows.length" class="mb-6 overflow-hidden rounded-lg border border-gray-200">
    <table class="w-full text-left text-sm">
      <caption v-if="title" class="bg-gray-50 px-4 py-3 text-left text-base font-semibold text-gray-900">
        {{ title }}
      </caption>
      <tbody class="divide-y divide-gray-200">
        <tr v-for="(row, index) in rows" :key="index">
          <th scope="row" class="w-1/3 bg-gray-50 px-4 py-3 align-top font-semibold text-gray-900 break-words">
            {{ row.label }}
          </th>
          <td class="px-4 py-3 align-top text-gray-700 break-words">
            <MarkdownText :content="row.value" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { MarkdownText } from "@estaly/ui";

export default {
  name: "InfoTable",
  components: { MarkdownText },
  props: {
    title: { type: String, default: "" },
    rows: { type: Array, default: () => [] },
  },
};
</script>
